import React, { useEffect } from "react";
import AssessmentTestInfoWrapper from "../../../components/candidate-assessment-flow/AssessmentTestInfoWrapper";
import ReactQuill from "react-quill";
import Radio from "../../../components/sub-component/Radio";
import {
  calculateTestResultPrevScore,
  isWhiteLabelClient,
} from "../../../utils/utilities";

export default function TestInstructionsAndInfoCard(props) {
  const {
    varrient,
    testName,
    testType,
    introText,
    activeSection,
    testResultPrev,
    setRetakeTest,
    retakeTest,
    assessmentData,
  } = props;

  const varrients = {
    startQualificatioTest: {
      title: "Qualification Test",
      disableSecondaryBtn: isWhiteLabelClient() ? true : false,
      secondaryBtnTitle: "Go back to dashboard",
      primaryBtnTitle: "Start test",
      style: {},
      points: [
        "To take the assessment you must pass the qualification test.",
        "If you do not pass the qualification test then you will not be able to take the assessment.",
      ],
      enablePointNo: false,
    },
    assessmentInstructions: {
      title: "Assessment Instructions",
      disableSecondaryBtn: isWhiteLabelClient() ? true : false,
      secondaryBtnTitle: "Not Now",
      primaryBtnTitle: "Start Assessment",
      style: {
        // width: "100%",
        // maxWidth: "100%",
      },
      points: [
        "This assessment may contain different types of tests which will be used to evaluate your skills and thought process. These can include multiple choice questions, text responses, video recording, coding challenges etc.",
        "Some of the questions may have a time limit, whereas others can be open ended. Please be mindful of the time limits. You will be able to see the progress of the assessment as well as time and sections remaining.",
        "Once you start the assessment, this window will go into fullscreen mode and you are expected to keep it that way till end of the assessment. Please note that we employ multiple measures to prevent cheating and this information is taken into account when shortlisting.",
        "You can pause the assessment at any time by escaping/closing the window and come back at a later time to resume it. Please note that you need to complete the assessment before the deadline mentioned above.",
        "Your assessment will be marked once it is finished, and you will be able to see your results in the test score panel in the candidate dashboard.",
        "Please note that if you have taken an assessment with Testfuse in the past, you will be able to use scores from your previous tests.",
      ],
      enablePointNo: true,
    },

    startTest: {
      title: testName || "Test Name",
      disableSecondaryBtn: true,
      disablePrimaryBtn: testResultPrev && retakeTest === null,
      secondaryBtnTitle: "",
      primaryBtnTitle: testResultPrev && !retakeTest ? "Next" : "Start Test",
      style: {},
      points: testResultPrev
        ? []
        : [
            `This is a test from the ${activeSection}. Kindly press “Start Test” to proceed further.`,
          ],
      enablePointNo: false,
    },
    pauseTest: {
      title: testName || "Test Name",
      disableSecondaryBtn: false,
      secondaryBtnTitle: "Go to dashboard",
      primaryBtnTitle: "Resume assessment",
      style: {},
      points: [
        "Your assessment and timer is paused right now, you can resume the assessment whenever you want or either you can go back to dashboard.",
      ],
      enablePointNo: false,
    },
    caseStudyIntroText: {
      title: "Case Study",
      disableSecondaryBtn: true,
      secondaryBtnTitle: "",
      primaryBtnTitle: "Yes I’m ready to start assessment",
      style: { width: "100%", maxWidth: "1280px" },
      points: [],
      enablePointNo: false,
    },
  };

  return (
    <AssessmentTestInfoWrapper
      test={props?.test?.test}
      varrient={varrient}
      assessmentData={assessmentData}
      style={varrients[`${varrient}`].style}
      title={varrients[`${varrient}`].title}
      disableSecondaryBtn={varrients[`${varrient}`].disableSecondaryBtn}
      disablePrimaryBtn={varrients[`${varrient}`].disablePrimaryBtn}
      secondaryBtnTitle={varrients[`${varrient}`].secondaryBtnTitle}
      primaryBtnTitle={varrients[`${varrient}`].primaryBtnTitle}
      onSecondaryBtnClick={props.onSecondaryBtnClick}
      onPrimaryBtnClick={props.onPrimaryBtnClick}
      btnWidth={
        varrient === "caseStudyIntroText" ||
        varrient === "pauseTest" ||
        varrient === "startTest" ||
        varrient === "assessmentInstructions" ||
        varrient === "startQualificatioTest"
          ? "max-content"
          : "120px"
      }
      processing={props.processing}
      loading={props.loading}
    >
      <div className="w-100 d-flex flex-column align-items-start">
        {varrients[`${varrient}`].points.map((point, _i) => {
          return (
            <div
              key={_i}
              className="d-flex flex-row"
              style={{
                textAlign: "left",
                marginTop: _i === 0 ? "0px" : "8px",
                gap: "6px",
              }}
            >
              <span className="body-2 dark-100">
                {varrients[`${varrient}`].enablePointNo && `${_i + 1}.`}
              </span>
              <span className="body-2 dark-100">{point}</span>
            </div>
          );
        })}
        {varrient === "startTest" && testResultPrev && (
          <div className="w-100 d-flex flex-column" style={{ gap: "12px" }}>
            <span className="body-2 dark-50 text-start">
              You attempted this test on{" "}
              <span className="dark-100">
                {new Date(testResultPrev?.attempted_at).toDateString()}
              </span>
              , and scored{" "}
              <span className="primary-text">
                {calculateTestResultPrevScore(
                  testResultPrev?.score_object,
                  testType,
                )}
                /10
              </span>
              . You can either use your previous results or retake the test.
            </span>
            <Radio
              varrient="radio-with-input"
              readonly
              placeholder=""
              dangerouslySetInnerHTML
              onChangeRadioOption={() => {
                setRetakeTest(false);
              }}
              checked={retakeTest === false}
              value={"I wish to proceed with my previous results"}
            />
            <Radio
              varrient="radio-with-input"
              readonly
              placeholder=""
              dangerouslySetInnerHTML
              onChangeRadioOption={() => {
                setRetakeTest(true);
              }}
              checked={retakeTest}
              value={"I want to retake this test"}
            />
          </div>
        )}
        {varrient === "assessmentInstructions" && (
          <span className="body-1 dark-100" style={{ marginTop: "24px" }}>
            {
              "We wish you a very best of luck! Please press start when you are ready"
            }
          </span>
        )}
        {varrient === "caseStudyIntroText" && (
          <span
            className="body-3"
            style={{ marginTop: "32px", marginBottom: "16px" }}
          >
            <ReactQuill
              className="ql-editor-test-instruction text-read-only disable-text-selection"
              theme="bubble"
              readOnly
              value={introText}
            />
          </span>
        )}
      </div>
    </AssessmentTestInfoWrapper>
  );
}
